import React from "react";
import { Link } from "react-router-dom";

interface Props {
	pathname: string;
	text: string;
}

const ButtonLink: React.FC<Props> = ({ pathname, text }) => {
	return (
		<Link
			to={pathname}
			className="btn bg-orange-500 text-white text-lg font-semibold"
		>
			{text}
		</Link>
	);
};

export default ButtonLink;
